/**
 * DeleteRedx component.
 *
 * @component
 * @param {object} props - The component props.
 * @param {string} [props.color] - The color of the SVG path. Defaults to "white".
 * @param {number | string} [props.size] - The size of the SVG. Defaults to 16.
 * @param {string} [props.className] - Additional CSS class name for the SVG element.
 * @param {any} [props.onClick] - The click event handler for the icon.
 * @returns {JSX.Element} - The PencilIcon SVG component.
 */
const PencilIcon = ({ color, size, onClick, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "16"}
      height={size ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
      onClick={onClick}
      className={className ?? ""}
    >
      <path
        d="M10.8685 2.86865C11.4934 2.24381 12.5064 2.24381 13.1313 2.86865C13.7561 3.49349 13.7561 4.50656 13.1313 5.1314L12.497 5.76571L10.2342 3.50297L10.8685 2.86865Z"
        fill={color ?? "white"}
      />
      <path
        d="M9.10285 4.63434L2.3999 11.3373V13.6H4.66264L11.3656 6.89708L9.10285 4.63434Z"
        fill={color ?? "white"}
      />
    </svg>
  );
};

export default PencilIcon;

/**
 *
 * @param {Object} props - The component props.
 * @param {string} [props.color] - The color of the SVG path. Defaults to "white".
 * @param {number | string} [props.size] - The size of the SVG. Defaults to 16.
 * @param {string} [props.className] - Additional CSS class name for the SVG element.
 * @param {any} [props.onClick] - The click event handler for the icon.
 * @returns {JSX.Element} - The PencilIcon SVG component.
 */
export const PencilIconOutline = ({ color, size, onClick, className }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "16"}
      height={size ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
      onClick={handleClick}
      className={className ?? ""}
    >
      <path
        d="M11.2411 2.99111L12.3661 1.86612C12.8543 1.37796 13.6457 1.37796 14.1339 1.86612C14.622 2.35427 14.622 3.14573 14.1339 3.63388L4.55479 13.213C4.20234 13.5654 3.76762 13.8245 3.28993 13.9668L1.5 14.5L2.03319 12.7101C2.17548 12.2324 2.43456 11.7977 2.78701 11.4452L11.2411 2.99111ZM11.2411 2.99111L13 4.75"
        stroke={color ?? "#545454"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
